@for (slot of slots$ | async; track slot; let i = $index) {
  <div class="slot" (click)="editSlot(i)">
    @if ((imageMap$ | async)[i]) {
      <img
      [src]="
                  {photoId:(imageMap$ | async)[i].photoId}
                    | getImageUrl
                      : ((imageMap$ | async)[i].photoId | getPhotoGroupFromPhotoId:imageRelations)
                      : 'anyone'
                      : context
                      : contextId
                      : 400
                    | async | cropCanvasPieceImage :(imageMap$ | async)[i].crop | async" />
      } @else {
        <h1>Wybierz zdjęcie {{i + 1}}.</h1>
      }
    </div>
  }
